module.exports = __webpack_public_path__ + "images/product-badges/product-badge-storyline-c2c4367f7eb223677f10b2761f889c63.webp";